import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Link } from 'react-router-dom';

const defaultCourses = [
  {
    CourseId: 1,
    CourseName: 'CUET-UG 2025',
    courseDesc: 'Complete preparation for CUET Undergraduate entrance exam',
    icon: '🎓',
    features: ['Comprehensive Study Material', 'Live Classes', 'Mock Tests', '24/7 Doubt Support'],
    studentsCount: 5000
  },
  {
    CourseId: 2,
    CourseName: 'JEE Main & Advanced',
    courseDesc: 'Expert-led preparation for engineering entrance exams',
    icon: '🚀',
    features: ['Physics, Chemistry, Maths', 'Previous Year Papers', 'Expert Doubt Solving', 'Performance Analytics'],
    studentsCount: 3500
  },
  {
    CourseId: 3,
    CourseName: 'NEET 2025',
    courseDesc: 'Complete medical entrance exam preparation course',
    icon: '⚕️',
    features: ['Biology Focus', 'Medical Terminology', 'Practice Tests', 'NCERT Based Content'],
    studentsCount: 4200
  },
  {
    CourseId: 4,
    CourseName: 'Foundation Course',
    courseDesc: 'Build strong fundamentals for competitive exams',
    icon: '📖',
    features: ['Class 9-10 Syllabus', 'Olympiad Prep', 'Concept Building', 'Weekly Tests'],
    studentsCount: 2800
  },
  {
    CourseId: 5,
    CourseName: 'Test Series',
    courseDesc: 'Practice with our comprehensive test series',
    icon: '📝',
    features: ['Full Length Tests', 'Chapter Tests', 'All India Ranking', 'Detailed Analysis'],
    studentsCount: 6500
  },
  {
    CourseId: 6,
    CourseName: 'Crash Course',
    courseDesc: 'Quick revision course for last-minute preparation',
    icon: '⚡',
    features: ['Quick Revision', 'Important Topics', 'Formula Sheets', 'Last Month Prep'],
    studentsCount: 1800
  }
];

const CoursesPage = () => {
  const [courses, setCourses] = useState(defaultCourses);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await api.get('/courses');
        if (response.data.success && response.data.data.length > 0) {
          setCourses(response.data.data);
        }
      } catch (error) {
        console.log('Using default courses');
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  return (
    <div className="pt-32 pb-16">
      {/* Header */}
      <div className="max-w-[1400px] mx-auto px-8 mb-16">
        <div className="text-center">
          <div className="hero-badge mb-8">🎯 Choose Your Path</div>
          <h1 className="text-5xl font-extrabold mb-6 gradient-text">Our Courses</h1>
          <p className="text-xl text-text-muted max-w-2xl mx-auto">
            Explore our comprehensive range of courses designed to help you achieve your academic goals
          </p>
        </div>
      </div>

      {/* Courses Grid */}
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <div key={course.CourseId || index} className="course-card">
              <div className="course-header">
                <div className="text-5xl mb-4">{course.icon || '📚'}</div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  {course.CourseName}
                </h3>
                <p className="text-text-muted text-sm">
                  {course.courseDesc || 'Expert-led preparation course'}
                </p>
              </div>
              
              <div className="p-8">
                <ul className="space-y-3 mb-8">
                  {(course.features || ['Comprehensive Study Material', 'Live Classes', 'Mock Tests']).map((feature, idx) => (
                    <li key={idx} className="text-text-light relative pl-6">
                      <span className="absolute left-0 text-accent-gold font-bold">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                {course.studentsCount && (
                  <p className="text-text-muted text-sm mb-6">
                    {course.studentsCount.toLocaleString()}+ students enrolled
                  </p>
                )}
                
                <a 
                  href="/subscriptions"
                  className="course-btn"
                  style={{ 
                    textDecoration: 'none',
                    width: '100%',
                    textAlign: 'center',
                    display: 'block',
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 10
                  }}
                  rel="noopener noreferrer"
                >
                  {loading ? 'Loading...' : 'Enroll Now'}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoursesPage;